import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FileTextIcon, DownloadIcon } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ICAMResourcesPage() {
  return <div className="w-full" data-id="element-1818" data-mp="10nbrrcoet7n8">
      {/* HERO SECTION */}
      <section className="section-navy hero-grid-pattern" data-id="element-1819" data-mp="1fd9j21hmydgn">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-1820" data-mp="1ffvr028fuuze">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} data-id="element-1821" data-mp="1ae6gqot1ilcd">
            <div className="text-sm font-bold text-nrs-light mb-4 uppercase tracking-wider" data-id="element-1822" data-mp="1odefxhp7dtgk">
              <Link to="/services" className="hover:text-nrs-orange" data-id="element-1823" data-mp="1jgfm709gboiw">
                Services
              </Link>{' '}
              &gt;{' '}
              <Link to="/services/identity-access-management" className="hover:text-nrs-orange" data-id="element-1824" data-mp="3q7wzes26bku3">
                ICAM
              </Link>{' '}
              &gt; Resources
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight max-w-4xl mx-auto" data-id="element-1825" data-mp="bd0xgmz201z0">
              ICAM Resources & Insights
            </h1>
            <div className="h-1.5 w-24 bg-nrs-orange mx-auto rounded-full mb-6" data-id="element-1826" data-mp="l93zztxti2mh"></div>
            <p className="text-xl text-nrs-light font-bold max-w-2xl mx-auto" data-id="element-1827" data-mp="q0m2imfhob9k">
              White papers, case studies, and technical guides for federal
              identity professionals
            </p>
          </motion.div>
        </div>
      </section>

      {/* FEATURED RESOURCES */}
      <section className="section-white" data-id="element-1828" data-mp="1404ykgv0zw5i">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-1829" data-mp="1416lbilem732">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1830" data-mp="18z8565qnmafl">
            <div className="card flex flex-col h-full border-t-4 border-t-nrs-orange" data-id="element-1831" data-mp="18wlv9zgajiu7">
              <FileTextIcon className="h-12 w-12 text-nrs-orange mb-6" data-id="element-1832" data-mp="35tb70ccb885c" />
              <div className="text-sm font-bold text-nrs-orange uppercase tracking-wider mb-2" data-id="element-1833" data-mp="3aquywf1xkjfr">
                Zero Trust Implementation Guide for Federal Agencies and
                Enterprises
              </div>
              <p className="text-gray-600 mb-8 flex-grow" data-id="element-1834" data-mp="2xsn5edzonabc">
                Step-by-step guide to implementing Zero Trust Architecture
                aligned with OMB M-22-09. Covers identity pillars,
                micro-segmentation, and continuous authentication.
              </p>
              <button className="btn-secondary w-full flex items-center justify-center gap-2" data-id="element-1835" data-mp="3lmwwublf40mc">
                <DownloadIcon className="h-4 w-4" data-id="element-1836" data-mp="3govclnc99v9a" />
                Download PDF
              </button>
            </div>

            <div className="card flex flex-col h-full border-t-4 border-t-nrs-navy" data-id="element-1837" data-mp="3vgdnx7u671mb">
              <FileTextIcon className="h-12 w-12 text-nrs-orange mb-6" data-id="element-1838" data-mp="3qfzrkn1xlg44" />
              <div className="text-sm font-bold text-nrs-orange uppercase tracking-wider mb-2" data-id="element-1839" data-mp="8amr0z85i4qm">
                FICAM Compliance Checklist
              </div>
              <p className="text-gray-600 mb-8 flex-grow" data-id="element-1840" data-mp="mwabymm6hdaj">
                Ensure your identity architecture aligns with Federal ICAM
                requirements. A comprehensive checklist covering governance,
                credentialing, and access management.
              </p>
              <button className="btn-secondary w-full flex items-center justify-center gap-2" data-id="element-1841" data-mp="dxydxzizfd82">
                <DownloadIcon className="h-4 w-4" data-id="element-1842" data-mp="iwt45mja4427" />
                Download Checklist
              </button>
            </div>

            <div className="card flex flex-col h-full border-t-4 border-t-nrs-navy" data-id="element-1843" data-mp="8w93akzo91ki">
              <FileTextIcon className="h-12 w-12 text-nrs-orange mb-6" data-id="element-1844" data-mp="3raibb3wxzobl" />
              <div className="text-sm font-bold text-nrs-orange uppercase tracking-wider mb-2" data-id="element-1845" data-mp="3rccvgg0e3cem">
                PIV/CAC Integration Best Practices
              </div>
              <p className="text-gray-600 mb-8 flex-grow" data-id="element-1846" data-mp="3hddn6yjjdis5">
                Technical guide for implementing phishing-resistant credentials
                across legacy and modern applications in DoD and IC
                environments.
              </p>
              <button className="btn-secondary w-full flex items-center justify-center gap-2" data-id="element-1847" data-mp="ohu7bptpx5gl">
                <DownloadIcon className="h-4 w-4" data-id="element-1848" data-mp="ok8360w82lp7" />
                Download Guide
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-navy" data-id="element-1849" data-mp="epy98ermtfcd">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-1850" data-mp="9thakqmt3il1">
          <h3 className="text-2xl font-bold mb-8 text-white" data-id="element-1851" data-mp="4u4nc4s0w9hx">
            Need Expert Guidance?
          </h3>
          <Link to="/contact-us" className="btn-primary" data-id="element-1852" data-mp="rrj5ksxcjn9">
            Request a Custom ICAM Assessment
          </Link>
        </div>
      </section>
    </div>;
}